import config from 'config';

/**
 * Enable hotjar script in production
 */
const isProd = config.PARTNERS_ENVIRONMENT === 'production';

/**
 * Hotjar tracking script to initialize and configure Hotjar on the client-side.
 *
 * This script dynamically appends the Hotjar tracking script to the document's `<head>`
 * if it hasn't already been added. It uses the provided `HOTJAR_ID` from the configuration
 * to uniquely identify the Hotjar instance for the application.
 *
 * The script ensures that:
 * - The Hotjar function (`hj`) is initialized and queued for execution.
 * - The Hotjar settings (`_hjSettings`) are configured with the provided `HOTJAR_ID` and version (`hjsv`).
 * - The script is only appended once to avoid duplicate loading.
 *
 * @constant
 * @type {string}
 * @example
 * // Ensure `config.HOTJAR_ID` is defined in your configuration before using this script.
 * // The script will automatically load Hotjar when included in your application.
 */

export const hotjar: React.JSX.IntrinsicElements['script'] | undefined = isProd
  ? {
      children: `
        (function(h,o,t,j,a,r){
            h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
            h._hjSettings={hjid:${config.HOTJAR_ID},hjsv:6};
            a=o.getElementsByTagName('head')[0];
            r=o.createElement('script');r.async=1;
            r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;

            if (!o.querySelector(\`script[src="\${r.src}"]\`)) {
              a.appendChild(r);
            }
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=')
      `,
    }
  : undefined;
